var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8MoinsOuGal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "96px",
    height: "96px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 34.556641 4.9902344 A 1.50015 1.50015 0 0 0 33.740234 5.2070312 L 10.740234 18.707031 A 1.50015 1.50015 0 0 0 10.699219 21.269531 L 33.699219 35.769531 A 1.5009861 1.5009861 0 1 0 35.300781 33.230469 L 14.386719 20.044922 L 35.259766 7.7929688 A 1.50015 1.50015 0 0 0 34.556641 4.9902344 z M 11.5 40 A 1.50015 1.50015 0 1 0 11.5 43 L 34.5 43 A 1.50015 1.50015 0 1 0 34.5 40 L 11.5 40 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8MoinsOuGal);
export default __webpack_public_path__ + "static/media/icons8-moins-ou-égal.95b11d4ef700fb81bd257ba4c670b45c.svg";
export { ForwardRef as ReactComponent };